export function errorScreenDecorator($provide) {
	'ngInject';
	$provide.decorator('$exceptionHandler', shExceptionHandler);
}

const nonFatalExceptions = [/\$sce:insecurl/, /\$rootScope:infdig/];

export function shExceptionHandler($delegate, $injector) {
	'ngInject';
	return (exception, cause) => {
		let ErrorScreen = $injector.get('ErrorScreen');
		if (ErrorScreen.isShowingError) {
			// error from ErrorScreen service or EventTracker service
			// that would cause an infinite loop
			console.error(exception);
			$delegate(exception, cause);
			return;
		}
		const reason = exception && exception.stack ? exception.stack : String(exception);
		if (nonFatalExceptions.some(regex => regex.test(reason))) {
			// non fatal; attempt to proceed normally
			return;
		}
		const homeUrl = window.isMobile ? 'mobile' : 'hub';
		const message = `
			Something went wrong on our end.
			Our engineering team has been notified.
			Give it a sec then reload the page.
			If the problem persists, <a href="/${homeUrl}">restart the app</a>
			or <a href="mailto:support@sharpr.com?subject=Server%20Error">contact us</a>.
		`;
		ErrorScreen.show({
			class: 'fail',
			title: 'BONK!',
			message: message,
			actionText: 'Reload',
			actionUrl: '',
			detailsText: reason,
			actionCallback: $event => {
				$event.preventDefault();
				window.location.reload(true);
			},
		});
		$injector.get('EventTracker').save('bonk', {
			error: exception.message || String(exception),
			trace: String(exception.stack || 'unknown'),
		});
		$delegate(exception, cause);
	};
}
